import React, { Component, createContext } from 'react';
import { GlobalContext } from '../contexts/GlobalContext';

export const QueryVSContext = createContext();

class QueryVSContextProvider extends Component {
	state = {
		bundle: {},
		apiurl:
			'https://r4.ontoserver.csiro.au/fhir/ValueSet?_sort=title&_count=15',
		// title: 'Abracadabra !!!!',
		filterName: '',
		filterTitle: '',
		filterStatus: '',
		filterTag: '',
		focalVS: '',
		expanded: false,
		expansionFilter: '',
		expansionValueSet: {},
		working: false
	};

	static contextType = GlobalContext;

	componentDidMount() {
		this.getData();
	}

	getNext = async () => {
		if (this.state.bundle.entry != null) {
			var nextUrl = this.state.bundle.link.filter(
				(x) => x.relation === 'next'
			);
			nextUrl = nextUrl[0].url;

			this.setState({ working: true });
			const response = await fetch(nextUrl);
			const jsonData = await response.json();
			this.setState({ working: false });

			this.setState({ bundle: jsonData });

			this.doAnalyticsEvent("Paging", "Next")
		}
	};

	getPrev = async () => {
		if (this.state.bundle.entry != null) {
			var prevUrl = this.state.bundle.link.filter(
				(x) => x.relation === 'previous'
			);
			prevUrl = prevUrl[0].url;

			this.setState({ working: true });
			const response = await fetch(prevUrl);
			const jsonData = await response.json();
			this.setState({ working: false });

			this.setState({ bundle: jsonData });

			this.doAnalyticsEvent("Paging", "Previous")
		}
	};

	doAnalyticsEvent(action, detail) {
		const { initAnalytics, logEventAnalytics } = this.context;
		initAnalytics();
		logEventAnalytics(
			"ValueSet",
			action,
			detail);

		console.log("Log");
	}

	getData = async () => {
		const { tagSystem } = this.context;

		var qUrl = this.state.apiurl;
		var query = '';

		if (this.state.filterName !== '') {
			query = `&name:contains=${this.state.filterName}`;
		}

		if (this.state.filterTitle !== '') {
			query = query + `&title:contains=${this.state.filterTitle}`;
		}

		if (this.state.filterStatus !== '') {
			query = query + `&status=${this.state.filterStatus}`;
		}

		if (this.state.filterTag !== '') {
			query = query + encodeURI(`&_tag=${tagSystem}|${this.state.filterTag}`);
		}

		this.setState({ working: true });
		const response = await fetch(qUrl + query);
		const jsonData = await response.json();
		this.setState({ working: false });

		this.setState({ bundle: jsonData });

		if (query !== '') {
			this.doAnalyticsEvent("Query", query)
		}
	};

	doExpansion = async (x) => {
		this.setState({ working: true });
		var qUrl = `${this.context.config.servers[0].url}ValueSet/${this.state.focalVS}/$expand?count=200`

		const response = await fetch(qUrl);
		const jsonData = await response.json();
		this.setState({
			expansionValueSet: jsonData,
			expanded: true,
			working: false
		});

		var expOk = (jsonData.resourceType === "ValueSet") ? "Success" : "Fail";
		this.doAnalyticsEvent("Expansion", expOk)
		console.log("Expanded ", jsonData)
	};

	getResource = async (x) => {
		var qUrl = `${this.context.config.servers[0].url}ValueSet/${x}`
		console.log(qUrl)
		const response = await fetch(qUrl)
		const jsonData = await response.json();
		this.setState({
			focalVS: x,
			resource: jsonData,
			expanded: false,
			expansionValueSet: {}
		});
		// this.setState({ resource: jsonData });
		// this.setState({ expanded: false });
		// this.setState({ expansionValueSet: {} });
	};

	setFilterName = (name) => {
		this.setState({ filterName: name });
	};

	setFilterTitle = (title) => {
		this.setState({ filterTitle: title });
	};

	setFilterTag = (tag) => {
		this.setState({ filterTag: tag });
	};

	setFilterStatus = (status) => {
		this.setState({ filterStatus: status });
	};

	setExpanded = (status) => {
		this.setState({ expanded: status });
	};

	render() {
		return (
			<QueryVSContext.Provider
				value={{
					...this.state,
					getData: this.getData,
					getNext: this.getNext,
					getPrev: this.getPrev,
					getResource: this.getResource,
					setFilterName: this.setFilterName,
					setFilterTitle: this.setFilterTitle,
					setFilterStatus: this.setFilterStatus,
					setFilterTag: this.setFilterTag,
					setExpanded: this.setExpanded,
					doExpansion: this.doExpansion
				}}
			>
				{this.props.children}
			</QueryVSContext.Provider>
		);
	}
}

export default QueryVSContextProvider;
